// Builds the /search/:location/:title route. Empty fields fall back to the
// "loc"/"term" placeholders that SearchView already understands, and values
// are URL-encoded so input like "Surrey, BC" or "a/b" can't break the route.
export function searchPath(term, location) {
  const title = (term || '').trim() || 'term';
  const place = (location || '').trim() || 'loc';
  return `/search/${encodeURIComponent(place)}/${encodeURIComponent(title)}`;
}
